import { createContext, ReactNode, useContext, useMemo, useState } from 'react'

import { format } from 'date-fns'

interface IWeekList {
  date: Date
  weekDay: string
}

interface ISharedDatesContextData {
  selectedDate: Date
  setSelectedDate: React.Dispatch<React.SetStateAction<Date>>
  selectedWeekDay: IWeekList
  setSelectedWeekDay: React.Dispatch<React.SetStateAction<IWeekList>>
}

interface IProps {
  children: ReactNode
}

const SharedDatesContext = createContext<ISharedDatesContextData>(
  {} as ISharedDatesContextData,
)

const SharedDatesProvider = ({ children }: IProps) => {
  const [selectedDate, setSelectedDate] = useState(new Date())

  const weekDay = format(new Date(), 'iii')
  const initialWeekDay = {
    date: new Date(),
    weekDay,
  }
  const [selectedWeekDay, setSelectedWeekDay] = useState(initialWeekDay)

  const value = useMemo(
    () => ({
      selectedDate,
      setSelectedDate,
      selectedWeekDay,
      setSelectedWeekDay,
    }),
    [selectedDate, selectedWeekDay],
  )

  return (
    <SharedDatesContext.Provider value={value}>
      {children}
    </SharedDatesContext.Provider>
  )
}

const useSharedDates = () => {
  const context = useContext(SharedDatesContext)

  if (!context) {
    throw new Error('useDate must be used within a SearchContextProvider')
  }

  return context
}

export { SharedDatesProvider, useSharedDates }
